import EditAccommodation from './EditAccommodation'
import EditAttraction from './EditAttraction'
import EditCar from './EditCar'
import EditEvent from './EditEvent'
import EditFlight from './EditFlight'
import EditNote from './EditNote'
import EditRestaurantBar from './EditRestaurantBar'
import EditThingToDo from './EditThingToDo'
import EditTourAndCruises from './EditTourAndCruises'
import EditTransport from './EditTransport'

import type { TripItem } from 'tripPlanner/types/tripItem'
import { assertUnreachable, isCustomItem } from 'tripPlanner/utils'
import ModalBody from 'LuxKit/Modal/ModalBody'
import { useIntl } from 'react-intl'

interface Props {
  item: TripItem
}

function EditTripItem({ item }: Props) {
  const intl = useIntl()
  if (!isCustomItem(item)) {
    // Safeguard, hopefully won't ever show
    return <ModalBody>{intl.formatMessage({
      id: '7ulHOeJDtjOg7x2O9R7u',
      defaultMessage: 'Error',
      description: 'Error message when editing a trip item in the trip planner feature',
    })}
    </ModalBody>
  }

  switch (item.type) {
    case 'ACCOMMODATION':
      return <EditAccommodation item={item} />
    case 'ATTRACTION':
      return <EditAttraction item={item} />
    case 'CAR_RENTAL':
      return <EditCar item={item} />
    case 'TOUR':
    case 'CRUISE':
      return <EditTourAndCruises item={item} />
    case 'FLIGHT':
      return <EditFlight item={item} />
    case 'NOTE':
      return <EditNote item={item} />
    case 'RESTAURANT_BAR':
      return <EditRestaurantBar item={item} />
    case 'OTHER_TRANSPORT':
    case 'TRAIN':
    case 'BUS':
    case 'FERRY':
      return <EditTransport item={item} />
    case 'EVENT':
      return <EditEvent item={item} />
    case 'THING_TO_DO':
      return <EditThingToDo item={item} />
    default:
      return assertUnreachable(item)
  }
}

export default EditTripItem
